// Japanese error messages for user-friendly error handling
// 日本語エラーメッセージ集

export const ERROR_MESSAGES = {
  // Authentication errors - 認証エラー
  AUTH: {
    LOGIN_FAILED: 'ログインできませんでした。入力内容をご確認ください。',
    INVALID_CREDENTIALS: 'メールアドレスまたはパスワードが間違っています。',
    USER_NOT_FOUND: '登録されていないメールアドレスです。',
    ACCOUNT_LOCKED: 'セキュリティのため一時的にロックされています。15分後に再度お試しください。',
    EMAIL_NOT_VERIFIED: 'メールアドレスの確認が完了していません。送信された確認メールをご確認ください。',
    TOKEN_EXPIRED: 'ログイン有効期限が切れました。もう一度ログインしてください。',
    TOKEN_INVALID: 'ログイン情報が無効です。もう一度ログインしてください。',
    PLAN_MISMATCH: 'プラン情報が変更されています。もう一度ログインしてください。',
    REGISTRATION_FAILED: '新規登録できませんでした。時間をおいてもう一度お試しください。',
    EMAIL_ALREADY_EXISTS: 'このメールアドレスは既に使用されています。',
    PASSWORD_RESET_FAILED: 'パスワードをリセットできませんでした。もう一度お試しください。',
    EMAIL_VERIFICATION_FAILED: 'メール認証に失敗しました。新しい認証メールを送信してください。',
    LOGOUT_FAILED: 'ログアウトできませんでした。ページを更新してください。'
  },

  // Form validation errors - フォーム入力エラー
  VALIDATION: {
    EMAIL_REQUIRED: 'メールアドレスを入力してください。',
    EMAIL_INVALID: 'メールアドレスの形式が正しくありません。',
    PASSWORD_REQUIRED: 'パスワードを入力してください。',
    PASSWORD_TOO_SHORT: 'パスワードは6文字以上にしてください。',
    PASSWORD_TOO_WEAK: 'パスワードは8文字以上で英数字を含めてください。',
    PASSWORD_MISMATCH: 'パスワードが一致しません。',
    CURRENT_PASSWORD_REQUIRED: '現在のパスワードを入力してください。',
    NEW_PASSWORD_REQUIRED: '新しいパスワードを入力してください。',
    CONFIRM_PASSWORD_REQUIRED: '確認用パスワードを入力してください。',
    SAME_PASSWORD_ERROR: '現在と同じパスワードは使用できません。',
    NAME_REQUIRED: 'お名前を入力してください。',
    PHONE_INVALID: '電話番号の形式が正しくありません。',
    PLAN_REQUIRED: 'プランを選択してください。',
    TERMS_REQUIRED: '利用規約への同意が必要です。'
  },

  // Network and connection errors - ネットワークエラー
  NETWORK: {
    CONNECTION_ERROR: 'インターネット接続を確認してください。',
    TIMEOUT_ERROR: '接続がタイムアウトしました。もう一度お試しください。',
    SERVER_ERROR: 'サーバーエラーが発生しました。時間をおいてお試しください。',
    MAINTENANCE: 'メンテナンス中です。しばらくお待ちください。',
    SERVICE_UNAVAILABLE: 'サービスを利用できません。時間をおいてお試しください。'
  },

  // Payment errors - 決済エラー
  PAYMENT: {
    CARD_DECLINED: 'カードが承認されませんでした。カード情報をご確認ください。',
    CARD_EXPIRED: 'カードの有効期限が切れています。',
    INSUFFICIENT_FUNDS: 'カードの利用限度額を超えています。',
    INVALID_CARD: 'カード情報が正しくありません。',
    PAYMENT_FAILED: '決済できませんでした。カード情報を確認するか、別のカードをお試しください。',
    SUBSCRIPTION_FAILED: 'プラン登録できませんでした。もう一度お試しください。',
    CANCELLATION_FAILED: 'プラン解約できませんでした。お問い合わせください。',
    BILLING_ERROR: '請求処理でエラーが発生しました。お問い合わせください。'
  },

  // Usage and quota errors - 使用量・制限エラー
  USAGE: {
    QUOTA_EXCEEDED: '利用回数の上限に達しました。プランをアップグレードしてください。',
    DAILY_LIMIT: '本日の利用上限に達しました。明日またご利用ください。',
    MONTHLY_LIMIT: '今月の利用上限に達しました。',
    RATE_LIMIT: '短時間に多くのリクエストがありました。少し待ってからお試しください。',
    PREMIUM_REQUIRED: 'この機能は有料プランでご利用いただけます。',
    UPGRADE_REQUIRED: 'この機能にはプランのアップグレードが必要です。'
  },

  // File upload errors - ファイルアップロードエラー
  FILE: {
    FILE_TOO_LARGE: 'ファイルが大きすぎます（5MB以下にしてください）。',
    FILE_TYPE_ERROR: '対応していないファイル形式です（JPEG/PNGのみ）。',
    UPLOAD_FAILED: 'アップロードできませんでした。もう一度お試しください。',
    OCR_FAILED: '文字を読み取れませんでした。鮮明な画像をお試しください。',
    IMAGE_PROCESSING_FAILED: '画像を処理できませんでした。別の画像をお試しください。'
  },

  // Medical advice errors - 医療アドバイスエラー
  ADVICE: {
    GENERATION_FAILED: 'アドバイスを作成できませんでした。入力内容を確認してください。',
    INVALID_INPUT: '入力内容に不足があります。すべての項目を入力してください。',
    PROCESSING_ERROR: '処理中にエラーが発生しました。もう一度お試しください。',
    AI_SERVICE_ERROR: 'AIサービスが一時的に利用できません。時間をおいてお試しください。'
  },

  // General errors - 一般的なエラー
  GENERAL: {
    UNKNOWN_ERROR: 'エラーが発生しました。もう一度お試しください。',
    ACCESS_DENIED: 'アクセスできません。',
    NOT_FOUND: 'ページが見つかりません。',
    FORBIDDEN: 'この操作はできません。',
    SESSION_EXPIRED: 'セッションの有効期限が切れました。ログインし直してください。',
    BROWSER_NOT_SUPPORTED: 'このブラウザには対応していません。Chrome、Safari、Edgeなどをご利用ください。'
  },

  // Account management errors - アカウント管理エラー
  ACCOUNT: {
    UPDATE_FAILED: 'プロフィールを更新できませんでした。',
    DELETE_FAILED: 'アカウントを削除できませんでした。お問い合わせください。',
    PASSWORD_CHANGE_FAILED: 'パスワードを変更できませんでした。現在のパスワードが正しいか確認してください。',
    EMAIL_CHANGE_FAILED: 'メールアドレスを変更できませんでした。このアドレスは既に使用されています。'
  }
};

// HTTP status code to Japanese error message mapping
// HTTPステータスコードから日本語エラーメッセージへのマッピング
export const HTTP_ERROR_MESSAGES = {
  400: '入力内容に問題があります。もう一度ご確認ください。',
  401: '認証が必要です。', // Generic 401 - サーバーから具体的なメッセージが来ることを期待
  402: '支払いが必要です。',
  403: 'アクセスが拒否されました。この操作を行う権限がありません。',
  404: 'お探しの内容が見つかりません。',
  405: 'この操作は許可されていません。',
  406: 'リクエスト形式が正しくありません。',
  407: 'プロキシ認証が必要です。',
  408: 'リクエストがタイムアウトしました。もう一度お試しください。',
  409: 'データの競合が発生しました。ページを更新してから再度お試しください。',
  410: 'このリソースは削除されています。',
  411: 'Content-Lengthヘッダーが必要です。',
  412: '前提条件を満たしていません。',
  413: 'アップロードファイルが大きすぎます。',
  414: 'URLが長すぎます。',
  415: 'サポートされていないファイル形式です。',
  416: '要求された範囲のデータを提供できません。',
  417: 'Expectヘッダーの条件を満たせません。',
  418: '私はティーポットです。', // RFC 2324
  421: 'リクエスト先が正しくありません。',
  422: '入力内容にエラーがあります。各項目をご確認ください。',
  423: 'このリソースは現在ロックされています。しばらくお待ちください。',
  424: '前の処理が失敗したため、この操作を完了できません。',
  425: 'リクエストが早すぎます。',
  426: 'プロトコルのアップグレードが必要です。',
  428: '事前条件が必要です。',
  429: 'リクエストが多すぎます。しばらく時間をおいてからお試しください。',
  431: 'リクエストヘッダーが大きすぎます。',
  451: '法的な理由により利用できません。',
  500: 'サーバーでエラーが発生しました。しばらくお待ちください。',
  501: 'この機能は未実装です。',
  502: 'ゲートウェイエラーが発生しました。しばらくお待ちください。',
  503: 'サービスが一時的に利用できません。メンテナンス中の可能性があります。',
  504: 'ゲートウェイタイムアウトが発生しました。',
  505: 'HTTPバージョンがサポートされていません。',
  506: 'サーバー設定にエラーがあります。',
  507: 'サーバーのストレージが不足しています。',
  508: 'ループが検出されました。',
  510: '拡張が必要です。',
  511: 'ネットワーク認証が必要です。'
};

// Error code to Japanese message mapping
// エラーコードから日本語メッセージへのマッピング  
export const ERROR_CODE_MESSAGES = {
  // Authentication codes
  'NO_TOKEN': ERROR_MESSAGES.AUTH.TOKEN_INVALID,
  'INVALID_TOKEN': ERROR_MESSAGES.AUTH.TOKEN_INVALID,
  'TOKEN_EXPIRED': ERROR_MESSAGES.AUTH.TOKEN_EXPIRED,
  'USER_NOT_FOUND': ERROR_MESSAGES.AUTH.USER_NOT_FOUND,
  'PLAN_MISMATCH': ERROR_MESSAGES.AUTH.PLAN_MISMATCH,
  'AUTH_FAILED': ERROR_MESSAGES.AUTH.LOGIN_FAILED,
  'EMAIL_NOT_VERIFIED': ERROR_MESSAGES.AUTH.EMAIL_NOT_VERIFIED,

  // Network codes
  'NETWORK_ERROR': ERROR_MESSAGES.NETWORK.CONNECTION_ERROR,
  'ECONNREFUSED': ERROR_MESSAGES.NETWORK.CONNECTION_ERROR,
  'ENOTFOUND': ERROR_MESSAGES.NETWORK.CONNECTION_ERROR,
  'TIMEOUT': ERROR_MESSAGES.NETWORK.TIMEOUT_ERROR,

  // Payment codes  
  'CARD_DECLINED': ERROR_MESSAGES.PAYMENT.CARD_DECLINED,
  'CARD_EXPIRED': ERROR_MESSAGES.PAYMENT.CARD_EXPIRED,
  'INSUFFICIENT_FUNDS': ERROR_MESSAGES.PAYMENT.INSUFFICIENT_FUNDS,

  // Usage codes
  'QUOTA_EXCEEDED': ERROR_MESSAGES.USAGE.QUOTA_EXCEEDED,
  'RATE_LIMIT_EXCEEDED': ERROR_MESSAGES.USAGE.RATE_LIMIT,
  'PREMIUM_REQUIRED': ERROR_MESSAGES.USAGE.PREMIUM_REQUIRED
};

/**
 * Get user-friendly Japanese error message from error object
 * @param {Error|Object} error - The error object
 * @returns {string} - User-friendly Japanese error message
 */
export const getErrorMessage = (error) => {
  if (!error) {
    return ERROR_MESSAGES.GENERAL.UNKNOWN_ERROR;
  }

  // If error already has a Japanese message, return it
  if (typeof error === 'string') {
    return error;
  }

  // Check if API interceptor added a user-friendly message
  if (error.userMessage) {
    return error.userMessage;
  }

  // Check if error has a specific error code
  if (error.response?.data?.code) {
    const codeMessage = ERROR_CODE_MESSAGES[error.response.data.code];
    if (codeMessage) {
      return codeMessage;
    }
  }

  // Check if error has a backend error message
  if (error.response?.data?.error) {
    return error.response.data.error;
  }

  if (error.response?.data?.message) {
    return error.response.data.message;
  }

  // Map HTTP status codes to Japanese messages
  if (error.response?.status) {
    const statusMessage = HTTP_ERROR_MESSAGES[error.response.status];
    if (statusMessage) {
      return statusMessage;
    }
  }

  // Handle network errors
  if (error.code === 'NETWORK_ERROR' || error.message === 'Network Error') {
    return ERROR_MESSAGES.NETWORK.CONNECTION_ERROR;
  }

  if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') {
    return ERROR_MESSAGES.NETWORK.TIMEOUT_ERROR;
  }

  if (error.code === 'ECONNREFUSED' || error.code === 'ENOTFOUND' || error.code === 'EHOSTUNREACH') {
    return ERROR_MESSAGES.NETWORK.CONNECTION_ERROR;
  }

  // Check error message for specific patterns
  if (error.message) {
    const message = error.message.toLowerCase();
    
    // Handle "Request failed with status code XXX" pattern
    const statusCodeMatch = message.match(/request failed with status code (\d+)/);
    if (statusCodeMatch) {
      const statusCode = parseInt(statusCodeMatch[1]);
      const statusMessage = HTTP_ERROR_MESSAGES[statusCode];
      if (statusMessage) {
        return statusMessage;
      }
    }
    
    // Handle axios-specific error patterns
    if (message.includes('network error') || message === 'network error') {
      return ERROR_MESSAGES.NETWORK.CONNECTION_ERROR;
    }
    
    if (message.includes('timeout') || message.includes('timed out')) {
      return ERROR_MESSAGES.NETWORK.TIMEOUT_ERROR;
    }
    
    if (message.includes('connection refused') || message.includes('econnrefused')) {
      return ERROR_MESSAGES.NETWORK.CONNECTION_ERROR;
    }
    
    if (message.includes('not found') || message.includes('enotfound')) {
      return ERROR_MESSAGES.NETWORK.CONNECTION_ERROR;
    }
    
    // Catch any remaining axios error patterns
    if (message.startsWith('request failed with status code')) {
      return ERROR_MESSAGES.GENERAL.UNKNOWN_ERROR;
    }
    
    if (message.includes('network') || message.includes('connection')) {
      return ERROR_MESSAGES.NETWORK.CONNECTION_ERROR;
    }
    
    if (message.includes('timeout')) {
      return ERROR_MESSAGES.NETWORK.TIMEOUT_ERROR;
    }
    
    if (message.includes('unauthorized') || message.includes('401')) {
      return ERROR_MESSAGES.AUTH.TOKEN_INVALID;
    }
    
    if (message.includes('forbidden') || message.includes('403')) {
      return ERROR_MESSAGES.GENERAL.ACCESS_DENIED;
    }
    
    if (message.includes('not found') || message.includes('404')) {
      return ERROR_MESSAGES.GENERAL.NOT_FOUND;
    }
  }

  // Default fallback message
  return ERROR_MESSAGES.GENERAL.UNKNOWN_ERROR;
};

/**
 * Check if an error requires reauthentication
 * @param {Error|Object} error - The error object
 * @returns {boolean} - True if reauthentication is required
 */
export const requiresReauth = (error) => {
  if (error.response?.data?.requiresReauth) {
    return true;
  }
  
  if (error.response?.data?.code === 'PLAN_MISMATCH') {
    return true;
  }
  
  if (error.response?.status === 401) {
    return true;
  }
  
  return false;
};

/**
 * Check if an error indicates email verification is required
 * @param {Error|Object} error - The error object
 * @returns {boolean} - True if email verification is required
 */
export const requiresEmailVerification = (error) => {
  return error.response?.data?.requiresVerification === true;
};

/**
 * Get appropriate action text for error (what user should do next)
 * @param {Error|Object} error - The error object
 * @returns {string} - Action text in Japanese
 */
export const getErrorAction = (error) => {
  if (requiresReauth(error)) {
    return '再度ログインしてください。';
  }
  
  if (requiresEmailVerification(error)) {
    return 'メールアドレスの確認を行ってください。';
  }
  
  if (error.response?.status === 429) {
    return 'しばらく時間をおいてから再試行してください。';
  }
  
  if (error.response?.status >= 500) {
    return 'サーバーに問題が発生しています。しばらく時間をおいてから再試行してください。';
  }
  
  return '入力内容をご確認いただき、再度お試しください。';
};

export default {
  ERROR_MESSAGES,
  HTTP_ERROR_MESSAGES,
  ERROR_CODE_MESSAGES,
  getErrorMessage,
  requiresReauth,
  requiresEmailVerification,
  getErrorAction
};